/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect,forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../formEnums/formValidation';
import Select2 from 'react-select'
import Checkbox from '../checkbox/checkbox';

const defaultSelect2Styles = (width = '250px') => ({
  container: (provided) => ({
    ...provided,
    zIndex: 3, // Set the width of the select component
    width,
    flexShrink: 0,
  }),
  control: (provided, state) => ({
    ...provided,
    width,
    minHeight: '40px', // Adjust the minimum height
    height: '40px', // Set the desired height
  }),
  menu: (provided, state) => ({
    ...provided,
    width,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '600px', // Set the maximum height for the scrollable menu list
    overflowY: 'auto',  // Ensure that the menu becomes scrollable when necessary
  }),
});
/**
 * Basic HTML select with an object array input parameter to bind to other react components
 */
const Select = forwardRef((props, ref) => {
  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRtl, setIsRtl] = useState(false);
  const {
    id, options, validation, onChange, value, className, 
    disabled, writable, noOptionsMessageText, customStyles
} = props;
  const [myOptions,setMyOptions] =useState([]);
  const [selectedOption,setSelectedOption]=useState({});
  const [valueState, setValueState] = useState(value);
  const onChangeValue = (element) => {
    if (element.target.value !== '') {
      let newValue = element.target.value;
      if(newValue === "true"){
        newValue = true;
      }else if(newValue === "false"){
        newValue = false;

      }
      setValueState(newValue);
      element.target.value = newValue;
      onChange(element);
    }
  };
  const onChangeSelect2Value=(element)=>{
    if(element.value && element.label){
      let newValue = element.value;
      if(newValue){
        setValueState(newValue);
        setSelectedOption(element);
        onChange({target:{value:element.value, option: element}});
      }
    }
  }

  useImperativeHandle(ref, () => ({
    updateValue(newValue) {
      if(newValue=="manager"){
        newValue = window.location.pathname.split('/')[window.location.pathname.split('/').length-1]
      }
      setValueState(newValue);
    },
  }));

  useEffect(() => {
    let newValue = value;
    if(newValue === true){
      newValue = "true";
    }else if(newValue === false){
      newValue = "false";

    }
    setIsDisabled(disabled);
    setValueState(newValue);
    
  }, [value, disabled]);

  useEffect(() => {
    let selected=null;
    let myOpt=options.map((option)=>{
      const label = option.name;
      const mapped = {
        value: option.value,
        label,
        ...option,
      };
      if(option.value==valueState){
        selected={...mapped, timestamp:Date.now()}; 
      }
      return mapped;  
    });
    setSelectedOption(selected);
    setMyOptions(myOpt);
  },[options]);

  const noOptionsMessage = () =>
    noOptionsMessageText || 'No options';

  const buildMergedStyles = (defaults, overrides) => {
    if (!overrides) return defaults;

    const merged = {};

    Object.keys(defaults).forEach((key) => {
      const baseFn = defaults[key];
      const override = overrides[key];

      if (!override) {
        merged[key] = baseFn;
        return;
      }

      if (typeof override === 'function') {
        merged[key] = (provided, state) => ({
          ...baseFn(provided, state),
          ...override(provided, state),
        });
      } else {
        merged[key] = (provided, state) => ({
          ...baseFn(provided, state),
          ...override,
        });
      }
    });

    return merged;
  };

  return (
      <>
      {!writable && <select
      id={id}
      className={`form-control border-${validation} ${className}`}
      onChange={onChangeValue}
      onClick={(e) => e.stopPropagation()}
      value={valueState || ''}
      disabled={disabled}
    >
      {options.map((option) => {
        let disabledReason=(option.disabledReason?option.disabledReason:"(Not allowed)");
        return (
        <option key={option.value} value={option.value} disabled={option.disabled}>{(option.disabled?option.name+" -- "+disabledReason:option.name)}</option>
      )}
      )}
    </select>}
    {writable==true && <>
    <Select2 className={` ${className} `}
        id={id}
        classNamePrefix="select"
        value={selectedOption}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isRtl={isRtl}
        styles={buildMergedStyles(defaultSelect2Styles(props?.width ?? "250px"), customStyles)}        
        isSearchable={isSearchable}
        options={myOptions}
        onChange={onChangeSelect2Value}
        noOptionsMessage={noOptionsMessage}
      />
      </>}
  </>
  );
});

Select.propTypes = {
  /**
   * Id of select input
   */
  id: PropTypes.string,
  /**
   * Array with object(name, value). It defines the select options
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  })).isRequired,
  /**
   * Input form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Selected value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array]),
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * Custom CSS classes
   */
  className: PropTypes.string,
  /**
   * To disable the select functionality
   */
  disabled: PropTypes.bool,
};

Select.defaultProps = {
  id: '',
  value: '',
  validation: FormValidation.PENDING,
  options: [],
  onChange: () => {},
  className: '',
  disabled: false,
  noOptionsMessageText: undefined,
  customStyles: null
};

export default Select;
